//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import template from './syndication-page.html';

import { IContentDrawerSettingsService } from '@redux/content-drawer/ContentDrawerSettingsService';
import { ContentDrawerSidebarOptions } from '@redux/content-drawer/ContentDrawerSidebarOptions';
import syndicationModule from '../syndication.module';

export class SyndicationPage {
  constructor(
    private readonly ContentDrawerSettingsService: IContentDrawerSettingsService,
  ) { }

  public $onInit() {
    this.ContentDrawerSettingsService.setPageSettings(ContentDrawerSidebarOptions.Share);
  }

  public $onDestroy() {
    this.ContentDrawerSettingsService.unsetPageSettings();
  }
}

syndicationModule.component('syndicationPage', {
  template,
  controller: [
    'ContentDrawerSettingsService',
    SyndicationPage,
  ],
});
